import { resolveAccess } from './resolve-access';
import { ACTION_BE_FLAG } from './permission-actions';

/**
 * PURE route guard for the Permission Access Layer (SA-1592 Phase A0).
 *
 * Returns the given route object only when the resolved menu grants the action;
 * otherwise returns undefined so the caller can omit the route from a router
 * children array. Built for A1 use — not consumed by the router in A0.
 *
 * Reads the snake_case BE flag (`can_read`, `can_create`, ...) directly off the
 * resolved menu object via ACTION_BE_FLAG. The camelCase ACTION_FLAG map is the
 * shape of the usePermission hook return, not the raw menu object — using it
 * here would always miss. Strict `=== true` keeps the gate fail-closed.
 *
 * @param {Array} menus - decrypted menus array.
 * @param {string} menuKey - a MENU key (or pathname) understood by resolveAccess.
 * @param {string} action - an ACTION enum value.
 * @param {object} routeObject - the route definition to return when allowed.
 * @returns {object|undefined} routeObject when allowed, otherwise undefined.
 */
export const routeIfAllowed = (menus, menuKey, action, routeObject) => {
  const flag = ACTION_BE_FLAG[action];
  if (!flag) return undefined;

  const access = resolveAccess(menus, menuKey);
  const isAllowed = access?.[flag] === true;
  return isAllowed ? routeObject : undefined;
};
